import {
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    Output,
    QueryList,
    ViewChild,
    ViewChildren,
} from '@angular/core';

import { keyboard } from '@ridango/core/lib/enums/keyboard.enum';

import { DropdownDefaultItemComponent } from './dropdown-default-item/dropdown-default-item.component';
import { DropdownRelatedCardItemComponent } from './dropdown-related-card-item/dropdown-related-card-item.component';

let identifier = 0;

@Component({
    selector: 'ridango-dropdown',
    templateUrl: './dropdown.component.html',
    styleUrls: ['./dropdown.component.css'],
})
export class DropdownComponent {
    @Input() isOpened = false;
    @Input() isDisabled = false;
    @Input() items: any[];
    @Input() selected: any;
    @Input() type = 'default';
    // field to show from 'translations' array
    @Input() displayField = null;
    @Input() hasIcon = false;
    @Input() placeholderText: string = null;
    @Input() locale = null;

    @Output() onItemSelected = new EventEmitter<any>();
    @Output() onDropdownToggle = new EventEmitter<any>();

    @ViewChildren('selectItem') selectItems: QueryList<DropdownDefaultItemComponent | DropdownRelatedCardItemComponent>;
    @ViewChild('dropdownButton', { static: true }) dropdownButton: ElementRef;

    listBoxId = `listbox-dropdown-${++identifier}`;
    listItemIdPrefix = `${this.listBoxId}-item-`;

    selectedIndex = -1;
    focusIndex = -1;

    constructor(public eRef: ElementRef) {}

    @HostListener('document:click', ['$event']) onClickOut(event) {
        if (!this.eRef.nativeElement.contains(event.target)) {
            this.onDropdownToggle.emit(false);
        }
    }

    openClicked(event) {
        event.stopPropagation();
        event.preventDefault();

        this.onDropdownToggle.emit(!this.isOpened);
        this.focusIndex = this.selectedIndex < 0 ? 0 : this.selectedIndex;
        setTimeout(() => this.selectItems.toArray()[this.focusIndex].focus());
    }

    itemSelected(item: any, index: number) {
        this.onItemSelected.emit(item);
        this.selectedIndex = index;
    }

    keyDown( event: KeyboardEvent ): void {
        switch (event.code) {
            case keyboard.ESCAPE:
                this.onDropdownToggle.emit(!this.isOpened);
                this.dropdownButton.nativeElement.focus();
                break;
            case keyboard.ENTER:
            case keyboard.SPACE:
            case keyboard.NUMPAD_ENTER:
                event.preventDefault();
                this.selected = this.items[this.focusIndex];
                this.itemSelected(this.selected, this.focusIndex);
                this.dropdownButton.nativeElement.focus();
                break;
            case keyboard.TAB:
                this.onDropdownToggle.emit(!this.isOpened);
                break;
            case keyboard.ARROW_DOWN:
            case keyboard.NUMPAD_2:
                event.preventDefault();
                this.setNextItemFocus(1);
                break;
            case keyboard.ARROW_UP:
            case keyboard.NUMPAD_8:
                event.preventDefault();
                this.setNextItemFocus(-1);
                break;
            case keyboard.HOME:
                event.preventDefault();
                this.focusIndex = 0;
                this.selectItems.toArray()[this.focusIndex].focus();
                break;
            case keyboard.END:
                event.preventDefault();
                this.focusIndex = this.items.length - 1;
                this.selectItems.toArray()[this.focusIndex].focus();
                break;
        }
    }

    private setNextItemFocus(direction: number): void {
        const n = this.items.length;
        let x = this.focusIndex + direction;
        if (x < 0) {
            x = 0;
        } else if (x >= n) {
            x = n - 1;
        }
        this.focusIndex = x;
        this.selectItems.toArray()[this.focusIndex].focus();
    }
}
